import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { MyTripsTicketNoComponent } from './mytrips-ticket-no.component';

@NgModule({ declarations: [MyTripsTicketNoComponent],
    exports: [MyTripsTicketNoComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MyTripsTicketNoModule {}
